import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import UpdateService from "./UpdateService";


export const getUpdates = createAsyncThunk("Update/get-Updates", async (token,thunkAPI) => {
  try {
    return await UpdateService.getUpdates(token);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createUpdate = createAsyncThunk(
  "Update/create-Updates",
  async (AssociationData, thunkAPI) => {
    try {
      return await UpdateService.createUpdate(AssociationData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getUpdate = createAsyncThunk(
  "Update/get-Update",
  async (id, thunkAPI) => {
    try {
      return await UpdateService.getUpdate(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateUpdate = createAsyncThunk(
  "Update/update-Update",
  async (id, thunkAPI) => {
    try {
      return await UpdateService.updateUpdate(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteUpdate = createAsyncThunk(
  "Update/delete-Update",
  async (id, thunkAPI) => {
    try {
      return await UpdateService.deleteUpdate(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Updates: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const AssociationSlice = createSlice({
  name: "Update",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUpdates.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUpdates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Updates = action.payload.data;
      })
      .addCase(getUpdates.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createUpdate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createUpdate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdUpdate = action.payload;
      })
      .addCase(createUpdate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getUpdate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUpdate.fulfilled, (state, action) => {
        state.isLoading = false; 
        state.isError = false;
        state.isSuccess = true;
        state.updatecontent= action.payload.data.content;
        state.updatetitle= action.payload.data.title;
      })
      .addCase(getUpdate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateUpdate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUpdate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedUpdate = action.payload;
      })
      .addCase(updateUpdate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteUpdate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteUpdate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedUpdate = action.payload;
      })
      .addCase(deleteUpdate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default AssociationSlice.reducer;
